import Model from '../Model'
import moment from "moment";

export default class RoutePlan extends Model {

    static async find(id) {
        const data = await Http.get(route('api.v2.external.route-plan', id))
        return this.make(data);
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        this.formattedDate = moment(attributes.date).format('DD/MM/YYYY');
        let tokens = [
            this.formattedDate,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    isInPast() {
        let date = new Date(this.date);
        let now = new Date();
        return date <= now;
    }

    async completeJob(job) {
        const url = route('api.v2.external.route-plan.jobs.complete', [this.id, job.id])
        await Http.put(url)
        const data = await Http.get(route('api.v2.external.route-plan', this.id))
        return this.fill(data)
    }

    async failJob(job) {
        const url = route('api.v2.external.route-plan.jobs.fail', [this.id, job.id])
        await Http.put(url)
        const data = await Http.get(route('api.v2.external.route-plan', this.id))
        return this.fill(data)
    }

    async resetJob(job) {
        const url = route('api.v2.external.route-plan.jobs.reset', [this.id, job.id])
        await Http.put(url)
        const data = await Http.get(route('api.v2.external.route-plan', this.id))
        return this.fill(data)
    }

}
